import Footer from 'components/Landpage/Footer';
import Header from 'components/Landpage/Header';
import { useEffect } from 'react';
import { ThemedComponent } from 'ui/theme';
import { Content } from './styled';

export default function ContainerLandpage({ children }) {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <ThemedComponent>
      <Content>
        <Header />
        {children}
        <Footer />
      </Content>
    </ThemedComponent>
  );
}
